import type { SanityPageBuilderGraphicStatsSection, SanityPageBuilderGraphicStatsStat, SanityPageBuilderSection, SanityPageBuilderStatsGraphicBar } from "@ouster/shared";
import { GraphicStatsBlockView } from "~/features/blocks/inventory/graphic-stats";
import { GraphicStatsGraphicBarView } from "~/features/blocks/inventory/graphic-stats/graphic/graphic-bar";
import { GraphicStatsStatView } from "~/features/blocks/inventory/graphic-stats/stat";
import { toCraftLinkArray } from "~/features/sanity/link";
import type { Mode, Theme } from "~/features/ui/get-theme-style";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderGraphicStatsSection;
  };
};
export function SanityGraphicStatsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const theme = (sectionSettings?.theme || "white") as Theme;
  const max = sectionContent.max ?? 0;
  const stats = sectionContent.stats ?? [];
  const graphic = sectionContent.graphic ?? [];
  return <GraphicStatsBlockView<SanityPageBuilderGraphicStatsStat, SanityPageBuilderStatsGraphicBar> anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} callToActionText={sectionContent.callToActionText} caption={sectionContent.caption} getBarKey={(bar, index) => bar._key || index} getStatKey={(stat, index) => stat._key || index} graphic={graphic} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} link={toCraftLinkArray(sectionContent.link)} mode={mode} renderBar={(bar, index, reveal) => <GraphicStatsGraphicBarView name={bar.name} value={bar.value} highlighted={bar.highlighted} tag={bar.tag} max={max} reveal={reveal} index={index} />} renderStat={stat => <GraphicStatsStatView stat={stat.stat} mode={mode} theme={theme} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} stats={stats} theme={theme} />;
}